import JobService from "utilities/services/jobs/job-service";
import JobStatuses from "models/enumerations/jobs/job-statuses";
import { ServiceResponse } from "@rsm-hcd/javascript-core";
import JobRecord from "models/view-models/job-record";

export const usePollJob = (jobId: number | null) => {
    const { get: getJob } = JobService.useGetQuery();

    const {
        data: job,
        isLoading,
        isError,
    } = getJob({ id: jobId! }, undefined, {
        enabled: jobId != null,
        refetchInterval,
    });

    return { job: job?.resultObject, isLoading, isError };
};

const refetchInterval = (result: ServiceResponse<JobRecord> | undefined) => {
    const job = result?.resultObject;

    const isFinished =
        job?.status === JobStatuses.Completed ||
        job?.status === JobStatuses.Errored;

    return isFinished ? false : 1000;
};
